export const CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE = 'CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE';

export const createStatementTemplatePlaceholderFailure = error => ({
    type: CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE,
    payload: error,
    error: true,
});
